import React from 'react';
import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import { fontSizes } from 'appconstants';
import { ReactSVG } from 'react-svg';
import { back_icon } from 'asset/icons';
import DailyReportFunctional from './index.function';
import SectionCard from 'components/SectionCard';
import RowView from 'components/RowView';

const DailyReport = () => {
  const { navigate } = DailyReportFunctional();

  return (
    <Wrapper>
      <div className='flex items-center gap-3 mb-6'>
        <div
          onClick={() => navigate(-1)}
          className='h-10 w-10 cursor-pointer rounded-md flex items-center justify-center bg-muted hover:bg-muted/50 transition'
        >
          <ReactSVG src={back_icon} />
        </div>
        <Text text='Daily Report' size={fontSizes.h24} className='font-bold' />
      </div>

      <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
        <SectionCard title='Arrival and Initial Observations'>
          <RowView
            value={
              <>
                Today, I returned to the warehouse to complete the remainder of the audit. I met with Brain and observed how he manages the bananas.
                He conducted a <br /> thorough room inspection, which included pulling samples from each room, cutting the fruit to assess its color
                stage and record temperatures - steps that wasn’t <br /> completed yesterday due to Jose’s busy schedule.
                <br /> Additionally, I want to mention that this facility makes its own gaskets from conveyor belts. I spoke with Tony, the
                maintenance guy, who mentions that this <br />
                solution works best for their facility, as the gaskets resist tearing better under the rough handling from the loaders.
                <br /> I also discussed Strella with Tony and Bill. Strella has been a consistent topic of at this facility. To summarize everyone’s
                stance: they hate it. They have expressed
                <br />
                frustration over the repeated rejection of their requests to upgrade control panels, which they believe would have been more
                cost-effective than adopting Strella.
                <br /> Furthermore, they see Strella as too good to be true, indicating skepticism about its actual benefits.
              </>
            }
            className='border-b-0'
            detailTextClassName='text-left'
          />
        </SectionCard>

        <SectionCard title='Produce Personnel Feedback'>
          <Text text='Overall happy with the quality and color they receive' className={'text-muted-foreground'} size={fontSizes.h14} />
          <Text
            text='Audit Summary – Previous Visit Comparison – Justin Miller (October 2023)
'
            className={'text-muted-foreground font-medium my-1.5'}
            size={fontSizes.h14}
          />
          <Text
            text='Upon review, findings from Justin previous report have been corrected:
'
            className={'text-muted-foreground'}
            size={fontSizes.h14}
          />

          <ul className='list-disc text-muted-foreground pl-4 mt-2'>
            <li>
              <Text
                text='Sanitation: Improved overall, inner door and pulp cords need some attention'
                className='text-muted-foreground fonr'
                size={fontSizes.h14}
              />
            </li>
            <li>
              <Text text='Structural: Torn curtains, gaskets have been replaced.' className='text-muted-foreground fonr' size={fontSizes.h14} />
            </li>
            <li>
              <Text
                text='Air Flow: All rooms have readings above the recommended range.'
                className='text-muted-foreground fonr'
                size={fontSizes.h14}
              />
            </li>
            <li>
              <Text
                text='Humidity: The readings are all below the recommended range of 90.0% - 95.0%.'
                className='text-muted-foreground fonr'
                size={fontSizes.h14}
              />
            </li>
          </ul>
        </SectionCard>
      </div>

      <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch mt-6'>
        <div className='space-y-6 h-full flex flex-col'>
          <SectionCard title='Audit Complete'>
            <Text text='All rooms inspected (6 out of service)' className='text-muted-foreground' size={fontSizes.h14} />
            <RowView label='Room Manufacturer' value='Thermal Technologies' />
            <RowView label='Capacity' value='18- 3-tier with 42-pallet capacity each' />
            <RowView label='Room Age' value='25(Rooms 1-11), 14 (Rooms 8-12) and 18 (Rooms 12 - 18)' />
            <RowView label='Ethylene Type' value='Easy-Ripe Catalytic Generator' />
            <RowView label='Door Type' value='Rollseal (Room 1 - 18) and BG Doors (Rooms 12 - 18)' />
            <RowView label='Humidifier Type' value='Stulz Humidifiers' className='border-b-0' />
          </SectionCard>
          <SectionCard title='Air Flow and Room Loading' className='flex-1'>
            <Text
              text='All Loaded rooms had static air pressure above the recommended minimum of 0.25 inches of water.'
              className='text-muted-foreground'
              size={fontSizes.h14}
            />
            <Text
              text={
                <>
                  Range:{' '}
                  <Text
                    text='0.26 – 0.44 inches of water. Room 14 was loaded improperly (shifted pallet)'
                    size={fontSizes.h14}
                    className='text-muted-foreground inline'
                  />
                </>
              }
              size={fontSizes.h14}
            />
            <Text text='Temperature Control' className='mt-2 font-bold' size={fontSizes.h18} />
            <Text
              text='Pulp temperatures in rooms were within 2°F of the control sensor readings except room 1, 2, 4, 5, 7, 9, 10, 12, 14, 16 and 18.'
              className='text-muted-foreground mb-2'
              size={fontSizes.h14}
            />
          </SectionCard>
        </div>

        <SectionCard title='Structural Observations'>
          <Text
            text='Room Leaks (Ethylene, Humidity, Room Cooling/Heating Efficiency):'
            className='text-muted-foreground mb-4'
            size={fontSizes.h14}
          />
          <RowView label='Door Leaks' value='Rooms 16, 17, 18' />
          <RowView label='Cracked Caulking' value='Rooms 16 and 18' />
          <RowView label='Door seals (wavy and pinched)' value='Rooms 16 and 18' />
          <RowView label='Missing Velcro' value='Room 5' className='border-b-0' />
          <Text text='Airflow:' className='text-muted-foreground mt-3 mb-2' size={fontSizes.h14} />
          <RowView label='Improperly Installed Gaskets' value='Rooms 16, 17, 18' />
          <RowView label='Improperly installed curtains' value='Rooms 16, 17, 18' />
          <RowView label='Gaps Between Sheet Metal & Racking' value='Rooms 16 and 17' />
          <RowView label='Gasket memory' value='Rooms 16 and 18' className='border-b-0' />
          <Text text='General Room Maintenance:' className='text-muted-foreground mt-3 mb-2' size={fontSizes.h14} />
          <RowView label='Damage on outer door' value='Rooms 16 and 18' />
          <RowView label='Torn curtains' value='Rooms 16 and 18' />
          <RowView label='Detached gasket strap' value='Rooms 16 and 18' className='border-b-0' />
        </SectionCard>
      </div>

      <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6'>
        <SectionCard title='Humidification and Ventilation'>
          <RowView label='Humidifier Function' value='All rooms functional except 13, 15, 17, 18, and 19' />
          <RowView label='Humidity Reading Range' value='78.1% – 87.8%' />
          <RowView label='Rooms Below Minimum' value='All loaded rooms' />
          <RowView label='Vent Function' value='Unobservable' className='border-b-0' />
        </SectionCard>

        <SectionCard title='Sanitation Observations'>
          <RowView label='Pulp Piece Cord Mold' value='Rooms 1, 2, 4, 7, 8, 9, 10, 11, 14, 15, 16, 17, 18' />
          <RowView label='Mold on Ceiling' value='Room 10' />
          <RowView label='Mold on Caulking' value='Rooms 12 and 15' />
          <RowView label='Mold inner/outer curtains' value='Rooms 12 and 15' />
          <RowView label='Dirt outer/inner door' value='Rooms 12 and 15' />
          <RowView label='Dirt and Debris' value='Rooms 12 and 15' />
          <RowView label='Debris on Coils' value='Rooms 12 and 15' className='border-b-0' />
        </SectionCard>
      </div>

      <SectionCard title='Ripening Process' className='mt-6'>
        <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6'>
          <div>
            <Text text='Room Checks' className='font-medium mb-2' size={fontSizes.h14} />
            <Text
              text='Samples are pulled and only color is used out of the indicators adjustments are made and notes are taken on ripening log'
              className='text-muted-foreground'
              size={fontSizes.h14}
            />
            <RowView label='Gassing Temperature' value='Unobservable' className='border-t mt-3' />
            <RowView label='2 Color Program' value='CV/OG: 2.5 -3.5' />
            <RowView label='Temperature Adjustments' value='Within 2°F at a time' />
            <RowView label='Gassing Protocol' value='24 hours' />
            <RowView label='Venting' value='Unknown' />
            <RowView label='Cycle Duration' value='5 days' />
            <RowView label='Staging and Selection Process' value='-' />
            <RowView label='Staging' value='-' className='border-b-0' />
          </div>
          <div>
            <Text text='Ripening Logs' className='font-medium mb-2' size={fontSizes.h14} />
            <Text
              text='Maintained with detailed entries for room numbers, receiving dates, number of cases, date and time of room checks, set points, temperatures, adjustments, gassing/shipment date and remarks.'
              className='text-muted-foreground'
              size={fontSizes.h14}
            />
            <RowView label='Start Time' value='12:00 PM' className='border-t mt-3' />
            <RowView label='Pallet Type' value='Partially sealed Pallets- no slip sheets are used' />
            <RowView
              label='Order Protection'
              value='Banana bags are used on all orders. Shrink wrap was inconsistently wrapped to the bottom of the pallet.'
              className='flex-col gap-3'
              detailTextClassName='text-left'
            />
            <RowView
              label='Product Handling'
              value='Selectors were seen handling the cases in a moderate to rough manner.'
              className='flex-col gap-3'
              detailTextClassName='text-left'
            />
            <RowView
              label='Dock Ambient Temperature/Time:'
              value='Orders are left on the dock for up to an hour/ 46.2'
              className='flex-col gap-3 border-b-0'
              detailTextClassName='text-left'
            />
          </div>
        </div>
      </SectionCard>

      <SectionCard title='Retail Store Visits' className='mt-6'>
        <Text text="Visited a total of 3 ACME (store #'s 1770, 0893 and 2693)" className='text-muted-foreground' size={fontSizes.h14} />

        <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6'>
          <div>
            <Text text='Conventional Bananas:' className='text-muted-foreground font-semibold mt-2' size={fontSizes.h14} />
            <RowView label='Brand' value='Dole' className='mt-3' />
            <RowView label='Farm' value='Costa Rica (0044, 0651 and 0611),' />
            <RowView label='Price' value='$0.75/lb' />
            <RowView label='Display Quality' value='2.5 - 3.0' />
            <RowView label='Color Range' value='3.5 – 4.5' />
            <RowView label='Display Type' value='Banana Pad' />
            <RowView label='Display Fullness' value='3⁄4 full' />
            <RowView label='Common Defects' value='BFL, Scarring and bruising' className='border-b-0' />
          </div>
          <div>
            <Text text='Organic Bananas:' className='text-muted-foreground font-semibold mt-2' size={fontSizes.h14} />
            <RowView label='Brand' value='Dole' className='mt-3' />
            <RowView label='Farm' value='Costa Rica (0044, 0651 and 0611),' />
            <RowView label='Price' value='$0.75/lb' />
            <RowView label='Display Quality' value='2.5 - 3.0' />
            <RowView label='Color Range' value='3.5 – 4.5' />
            <RowView label='Display Type' value='Banana Pad' />
            <RowView label='Display Fullness' value='3⁄4 full' />
            <RowView label='Common Defects' value='BFL, Scarring and bruising' className='border-b-0' />
          </div>
        </div>
      </SectionCard>
    </Wrapper>
  );
};

export default DailyReport;
